import { getAdminSessionToken } from "../services/sessionStorage";
import {
  IS_DEV_ENV,
  IS_INTEGRATION_ENV
} from "../shared/constants/environment";

/**
 * Applies the shared Wingspan policy that excludes internal and administrative
 * sessions from third-party analytics.
 */
export const shouldSendAnalyticsCall = (): boolean => {
  if (window.forceSendSegment) {
    return true;
  }

  if (!IS_INTEGRATION_ENV && (IS_DEV_ENV || window.TEST_ENV)) {
    return false;
  }

  const isAdminSession = !!getAdminSessionToken();
  const isWingspanUser = !!window.userEmail?.includes("wingspan.app");

  return !isWingspanUser && !isAdminSession;
};
